var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"main"},[_c('transition',{attrs:{"mode":"out-in","name":"slide-fade"}},[_c('router-view')],1),_c('Toast',{attrs:{"position":"top-right"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }